export enum PeriodSelection {
  OneHour,
  SixHours,
  TwelveHours,
  OneDay,
  SevenDays,
  ThirtyDays,
  OneYear,
  ThreeYears,
  FiveYears,
  Custom
}
